import gql from 'graphql-tag';
export default gql`
  mutation uploadWetSignature($applicationId: String!, $wetSignatureObjName: String!, $uploadFileObj: JSON!) {
    uploadWetSignature(applicationId: $applicationId, wetSignatureObjName: $wetSignatureObjName, uploadFileObj: $uploadFileObj) {
      url
    }
  }
`;
